import Vue from "vue";
import * as firebase from "firebase/app";
import "firebase/auth";
import "firebase/database";
import "firebase/firestore";
import "firebase/storage";
import "firebase/functions";
import "firebase/analytics";

var config = {
  apiKey: "AIzaSyABxDSyL8HRFYm_5Nii0ftaLs4OCRK92Eo",
  authDomain: "flexi-comms.firebaseapp.com",
  databaseURL: "https://flexi-comms.firebaseio.com",
  projectId: "flexi-comms",
  storageBucket: "flexi-comms.appspot.com",
  messagingSenderId: "310321532284",
  appId: "1:310321532284:web:e0d3be0b78d060d312e8f9",
  measurementId: "G-1RVC1YZ0FL",
};

let host = window.location.host;
if (
  host == "localhost:8080" ||
  host == "localhost:8081" ||
  host == "localhost:8082" ||
  host == "192.168.178.21:8080" ||
  host == "192.168.178.21:8081" ||
  host == "192.168.178.21:8082" ||
  host == "10.0.0.9:8080" ||
  host == "flexicomms.firebaseapp.com" ||
  host.substring(0, 4) == "dev."
) {
  var config = {
    apiKey: "AIzaSyCXjnHMoXf4jQLMYw_jsB2krmkSDxh_z78",
    authDomain: "flexicomms.firebaseapp.com",
    databaseURL: "https://flexicomms.firebaseio.com",
    projectId: "flexicomms",
    storageBucket: "flexicomms.appspot.com",
    messagingSenderId: "682381773868",
    appId: "1:682381773868:web:f5aaf4e0714d2eb737d589",
    measurementId: "G-ZGRT3SXLKQ",
  };
}

if (!firebase.apps.length) {
  firebase.initializeApp(config);
}

let cloneFunction = function(obj) {
  return JSON.parse(JSON.stringify(obj));
};

firebase.analytics();
Vue.prototype.analytics = firebase.analytics();
export const clone = cloneFunction;
export const GoogleProvider = new firebase.auth.GoogleAuthProvider();
export const auth = firebase.auth();
export const dataB = firebase.database();
export const DB = firebase.firestore();
export const files = firebase.storage().ref();
export const driverRef = DB.collection("Drivers");
export default firebase;
